<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GNIMPv/tc-custom/9780830841868.jpg?1696025164111" alt="This image is the cover for the book Reading the Times"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reading the Times
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Christianity Today</em> Book Award<br/> The Gospel Coalition Book Awards Honorable Mention<br/> <em>Foreword</em> INDIES Book of the Year Award Finalist<br/> ECPA Top Shelf Book Cover Award</strong> </p> <p> <strong>"Reading the morning newspaper is the realist's morning prayer."—G. W. F. Hegel</strong> </p> <p>Whenever we reach for our phones or scan a newspaper to get "caught up," we are being not merely informed but also <em>formed</em>. News consumption can shape our sense of belonging, how we judge the value of our lives, and even how our brains function. Christians mustn't let the news replace prayer as Hegel envisioned, but neither should we simply discard the daily feed. We need a better understanding of what the news is for and how to read it well.</p> <p>Jeffrey Bilbro invites readers to take a step back and gain some theological and historical perspective on the nature and very purpose of news. In <em>Reading the Times</em> he reflects on how we pay attention, how we discern the nature of time and history, and how we form communities through what we read and discuss. Drawing on writers from Thoreau and Dante to Merton and Berry, along with activist-journalists such as Frederick Douglass and Dorothy Day, Bilbro offers an alternative vision of the rhythms of life, one in which we understand our times in light of what is timeless. Throughout, he suggests practices to counteract common maladies tied to media consumption in order to cultivate healthier ways of reading and being.</p> <p>When the news sets itself up as the light of the world, it usurps the role of the living Word. But when it helps us attend together to the work of Christ—down through history and within our daily contexts—it can play a vital part in enabling us to love our neighbors. <em>Reading the Times</em> is a refreshing and humane call to put the news in its place.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey Bilbro
      </h2>
      
      <p class="authorDescription body article"><p>Jeffrey Bilbro (PhD, Baylor University) is the editor-in-chief of <em>Front Porch Republic</em> and associate professor of English at Grove City College. He is also the author of <em>Loving God's Wildness: The Christian Roots of Ecological Ethics in American Literature</em> and <em>Virtues of Renewal: Wendell Berry's Sustainable Forms</em>, and coauthor (with Jack Baker) of<em>Wendell Berry and Higher Education: Cultivating Virtues of Place</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e79f92e